import { createStore } from 'redux';
import reducers from 'reducers/index';
import stateEnhancer from 'core/stateEnhancer';

const store = createStore(reducers, /* instead middleware => */ stateEnhancer);

// must run saga after store is created
import sagas from 'sagas';
import {sagaMiddleware} from 'core/middlewares';

sagaMiddleware.run(sagas);


export default store;



// WEBPACK FOOTER //
// ./src/core/store.js